import React, { Fragment, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";

import { Input, Measurement as MeasurementInput } from "../../../../form-inputs/inputs";
import { Typeahead, AsyncTypeahead } from "../../../../form-inputs/typeahead";
import { SoftValidationProvider } from "../../../../../contexts/soft-validation/soft-validation-provider";

const FactItem = ({ enableWarning, isNewTemplateUsed, isNutrition, isDietary, tooltipPosition, ...props }) => {
    const assignProviderUrl = useMemo(() => {
        // this API call has to be done only on NFP nutrient section
        if (isNutrition && isDietary) {
            return `/picklists/${isNewTemplateUsed ? "DietaryStandardNutrientsNew" : "DietaryStandardNutrientsOld"}`;
        }

        return "/picklists/nutrition/";
    }, [isNutrition, isDietary, isNewTemplateUsed]);

    const removeNutrient = async () => {
        await props.removeNutrient(props.data[0].nutrient.value);
        const elID = props.factId.split("of")[0];
        const focusItem = document.querySelectorAll(`[id^="noteMark_${elID}"]`)[0];
        const nutrientBtns = document.getElementsByName("newNutrient");
        const nutrientBtnFocus = elID.includes("dietary") ? nutrientBtns[0] : nutrientBtns[1];
        focusItem ? focusItem.focus() : nutrientBtnFocus.focus();
    };

    const columnItems = props.data;

    const noteMark = columnItems[0].noteMark || "";
    const factName = columnItems[0].nutrient || "";
    const description = columnItems[0].description || "";

    const id = columnItems[0].nutrient.value;
    const columns = columnItems.map((item, c) => {
        const hasWarning = !!item.nutrient.dataQualityIssue;

        return (
            <Fragment key={`fact_item_fields_${props.factId}_${c}`}>
                <SoftValidationProvider
                    key={`fact_item_fields_${props.factId}_${c}`}
                    enableWarning
                    hasWarning={hasWarning}
                    tooltip={hasWarning ? item.nutrient.dataQualityIssue.message : undefined}
                >
                    <MeasurementInput
                        id={`${props.factId}_${c}_uom`}
                        name="uom"
                        valueAsString={true}
                        filter={["nutrient"]}
                        defaultValue={{ value: item.quantity, uom: item.uom }}
                        updateOnChange={(name, value) => {
                            props.updateField(id, name, value, c);
                        }}
                        lengthRestriction={5}
                        tooltipPosition={tooltipPosition}
                    />
                </SoftValidationProvider>
                <MeasurementInput
                    id={`${props.factId}_${c}_pdv`}
                    name="pdv"
                    valueAsString={true}
                    defaultValue={item.pdv}
                    updateOnChange={(name, value) => {
                        props.updateField(id, name, value, c);
                    }}
                    lengthRestriction={5}
                    tooltipPosition={tooltipPosition}
                />
            </Fragment>
        );
    });
    const descInput = props.showDescription ? (
        <Input
            name="description"
            className="fact-description"
            label="Description"
            value={description}
            updateOnChange={(name, value) => {
                props.updateField(id, name, value, false);
            }}
        />
    ) : null;

    return (
        <div
            className="fact-item"
            style={props.columnStyle}
        >
            <Typeahead
                id={`noteMark_${props.factId}`}
                name="noteMark"
                defaultValue={noteMark}
                options={props.noteMarkList}
                updateOnChange={(name, value) => props.updateField(id, name, value, false)}
                className="-x-small"
            />
            <div className="form-field">
                <AsyncTypeahead
                    id={`nutrient_${props.factId}`}
                    name="nutrient"
                    defaultValue={factName}
                    creatable={!isDietary || !isNutrition}
                    provider={assignProviderUrl}
                    updateOnChange={(name, value) => props.updateField(id, name, value, false)}
                    lengthRestriction={150}
                />
            </div>
            {columns}
            <button
                className="button -primary -small"
                onClick={removeNutrient}
            >
                <FontAwesomeIcon icon={faTrashAlt} />
            </button>
            {descInput}
        </div>
    );
};

export default FactItem;
